import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2ecd1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "log-list-header",
  class: "row g-4 py-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "log-list-header-title",
  class: "col-lg-3 d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("h6", { style: {"color":"var(--cor_texto_1)"} }, "Lista de Vendedores")
], -1))
const _hoisted_3 = {
  id: "log-list-header-search",
  class: "col-sm-9 col-lg-7"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  style: {"color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_5 = { class: "col-sm-3 col-lg-2" }
const _hoisted_6 = { class: "card rounded mb-4 p-4" }
const _hoisted_7 = { class: "row g-4" }
const _hoisted_8 = { class: "col-md-6 col-lg-3" }
const _hoisted_9 = { class: "col-md-12 col-lg-3 d-flex align-items-center justify-content-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-filter",
  "aria-hidden": "true",
  style: {"font-size":"1.2rem"}
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Filtrar", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  id: "box-table-competitors",
  class: "background_1 card"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-eye",
  "aria-hidden": "true",
  style: {"color":"white","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_303_15)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M50 56.25C65.5273 56.25 78.125 43.6523 78.125 28.125C78.125 12.5977 65.5273 0 50 0C34.4727 0 21.875 12.5977 21.875 28.125C21.875 43.6523 34.4727 56.25 50 56.25ZM75 62.5H64.2383C59.9023 64.4922 55.0781 65.625 50 65.625C44.9219 65.625 40.1172 64.4922 35.7617 62.5H25C11.1914 62.5 0 73.6914 0 87.5V90.625C0 95.8008 4.19922 100 9.375 100H90.625C95.8008 100 100 95.8008 100 90.625V87.5C100 73.6914 88.8086 62.5 75 62.5Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M75 62.5H64.2383C59.9023 64.4922 55.0781 65.625 50 65.625C44.9219 65.625 40.1172 64.4922 35.7617 62.5H25C11.1914 62.5 0 73.6914 0 87.5V90.625C0 95.8008 4.19922 100 9.375 100H90.625C95.8008 100 100 95.8008 100 90.625V87.5C100 73.6914 88.8086 62.5 75 62.5Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_303_15" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "100",
        height: "100",
        fill: "white"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CampBtnGenerateExcel = _resolveComponent("CampBtnGenerateExcel")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_CampEmptyListFeedbackV2 = _resolveComponent("CampEmptyListFeedbackV2")!
  const _component_CampFooterPaginationControl = _resolveComponent("CampFooterPaginationControl")!
  const _component_ModalErroInfo = _resolveComponent("ModalErroInfo")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.keywordSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywordSearch) = $event)),
          placeholder: "Filtre por palavra chave nesta página",
          type: "text",
          disabled: _ctx.isLoading
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CampBtnGenerateExcel, {
          "table-data": _ctx.printCompetitors,
          label: `Exportar`,
          "file-name": `Relação de vendedores`,
          "btn-class": "btn_background_1 btn-sm",
          "hidden-column-list": ['id_job', 'updated_at', 'id_company','id','financial_data'],
          "renamed-column-list": [
                'return as JSON',
                'name as Nome',
                'deleted_at as Deletado em',
                'latestAccess as Último acesso',
                'birth_date as Data de nascimento',
                'use_version as Versão do app',
                'card_number as Cartão',
                'card_pin as Pin',
                'store as Loja',
                'latestAccessCode as cód.Acesso',
                'id_role as Nível',
                'storeName as Loja',
                'companyName as Companhia',
                'created_at as Data de Criação',
              ]
        }, null, 8, ["table-data", "renamed-column-list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.selectedStores,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStores) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            clearable: "",
            placeholder: "Selecione uma ou mais lojas",
            class: "w-100",
            onChange: _ctx.filterCompetitors
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeList, (store) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: store.id,
                  label: store.fantasy_name,
                  value: store.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchCompetitors())),
            class: "btn btn-sm w-100 h-100 background_btn_1_opct"
          }, _hoisted_12)
        ])
      ])
    ]),
    (!_ctx.isLoading && _ctx.printCompetitors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_CampTable, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("CPF")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Nome")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("E-mail")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Telefone")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cód.Acesso")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Loja")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Status")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, {
                    class: "py-4 text-center",
                    style: {"width":"15rem"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Detalhes")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printCompetitors, (competitor) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(competitor.cpf || " - "), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(competitor.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(competitor.email), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(competitor.tel), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(competitor.latestAccessCode || " - "), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(competitor.use_version || " - "), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(competitor.deleted_at ? 'Inativo' : 'Ativo'), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center py-1" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-sm background_btn_1",
                          onClick: ($event: any) => (_ctx.ModalErroInfoLog(competitor))
                        }, _hoisted_16, 8, _hoisted_14)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 256))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.printCompetitors.length)
      ? (_openBlock(), _createBlock(_component_CampEmptyListFeedbackV2, {
          key: 2,
          id: "competitors-icon-empty-list-feedback"
        }, {
          icon: _withCtx(() => [
            _hoisted_17
          ]),
          message: _withCtx(() => [
            _createTextVNode("Não há nada para mostrar")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.printCompetitors.length)
      ? (_openBlock(), _createBlock(_component_CampFooterPaginationControl, {
          key: 3,
          class: "mt-5 mb-20",
          index: _ctx.pageID,
          total: _ctx.pageTotal,
          "onGet:UpdatedPageID": _cache[3] || (_cache[3] = (ID) => _ctx.handlePaginationRendering(ID))
        }, null, 8, ["index", "total"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalErroInfo, {
      toggle: _ctx.ModalErroInfo.toggle,
      competitorErros: _ctx.ModalErroInfo.competitorErros
    }, null, 8, ["toggle", "competitorErros"])
  ]))
}